export default {
  hint: {
    display: 'flex',
    textAlign: 'left',
    padding: '0 4px'
  }
}
